import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { trusts as enumeratedTrusts } from 'Consts/EnumeratedValues';
import EditButtonLink from 'Components/Blueprint/UI/EditButtonLink';
import Short from 'Components/Format/DateFormat/Short';
import ImageHeading from '../ImageHeading';

const Trusts = ({ trusts, editLink }) => (
  <td className="trusts">
    <ImageHeading className="trusts">
      Trusts
      {editLink && (<EditButtonLink
        title="Edit Trusts"
        to={editLink}
      />)}
    </ImageHeading>
    {trusts.length > 0 ? (
      trusts.map(trust => (
        <div className="trust item" key={`${trust.id}t`}>
          <div className="name">{trust.attributes.grantor}</div>
          {trust.attributes.type !== '' && (
            <div>
              Type:&nbsp;
              {enumeratedTrusts('type', trust.attributes.type)}
            </div>
          )}
          {trust.attributes.dateExecuted !== '' && (
            <div>
              Executed:&nbsp;
              <Short date={trust.attributes.dateExecuted} />
            </div>
          )}
          {trust.attributes.trustee !== '' && (
            <div>
              Trustee:&nbsp;
              {trust.attributes.trustee}
            </div>
          )}
          {trust.attributes.beneficiary !== '' && (
            <div>
              Beneficiary:&nbsp;
              {trust.attributes.beneficiary}
            </div>
          )}
          <div>
            Funded:&nbsp;
            {trust.attributes.isFunded ? 'Yes' : 'No'}
          </div>
          {trust.attributes.isFunded && trust.attributes.fundedDetails !== '' && (
            <div>
              Funded Details:&nbsp;
              {trust.attributes.fundedDetails}
            </div>
          )}
        </div>
      ))
    ) : (
      <Fragment>
        <p>No trusts.</p>
      </Fragment>
    )}
  </td>
);

Trusts.propTypes = {
  trusts: PropTypes.array.isRequired,
  editLink: PropTypes.string,
};
Trusts.defaultProps = {
  editLink: null,
};

export default Trusts;
